import React from 'react'
// import LoadingGif from '../../res/loading.gif'
import './style.scss'

export default function Loading(props: any) {
    if (props.isLoading) {
        if (props.timedOut) {
            return <div>Loader timed out!</div>
        } else if (props.pastDelay) {
            return (
                <div className='loading'>
                    {/* <img className='spin-indicator' src={LoadingGif} alt='' /> */}
                    loading...
                </div>
            )
        } else {
            return null
        }
    } else if (props.error) {
        return <div>Error! Component failed to load</div>
    } else {
        return null
    }
}
